import classNames from "classnames";
import "./index.scss"
import {PopOver} from "../PopOver";

export const FormField = ({ label, htmlFor, error, required, children, disabled, className, popoverText, popoverClassName, popoverStyle, labelStyle, formFieldClassName }) => {
    const cn = classNames("self-end",className)
    return (
        <div className={cn}>
            <div className={classNames("formField", formFieldClassName, { error, disabled })}>
                {!!label && (
                    <label htmlFor={htmlFor} className={classNames("text-sm text-black font-medium", labelStyle)}>
                        {required && (
                            <span
                                className="text-red-500"
                                title="Обязательное поле"
                            >
                                *
                            </span>
                        )}
                        {" "}{label}
                    </label>
                )}
                {children}
                {error && <span className="text-red-500 text-sm">{error}</span>}
                {popoverText && disabled && <PopOver style={popoverStyle} className={popoverClassName}>{popoverText}</PopOver>}
            </div>
        </div>
    );
};
